<template>
  <v-dialog :value="value" max-width="415px" @input="onInput">
    <v-card>
      <v-card-title>
        メモを編集
      </v-card-title>

      <v-card-text style="font-size: 14px">
        <v-textarea
          filled
          label="メモ"
          auto-grow
          hide-details
          class="mt-4 mb-6"
          :value="memo"
          @input="onInput"
        />
      </v-card-text>

      <v-card-actions class="pt-0">
        <v-spacer/>
        <v-btn
          class="mr-2 mb-2"
          color="primary"
          outlined
          depressed
          @click="onClose"
        >
          キャンセル
        </v-btn>

        <v-btn
            class="mr-4 mb-2"
            color="primary"
            depressed
            @click="onUpdate"
        >
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MemoEditDialog",
  components: {},
  props: {
    value: {
      type: Boolean
    },
    user: {
      type: Object
    }
  },
  data() {
    return {
      memo: null
    }
  },
  methods: {
    onClose() {
      this.$emit('input', false)
    },
    onUpdate() {
      this.$emit('update', this.memo || null)
    },

    onInput(value) {
      this.memo = value
    }
  },
  watch: {
    user: {
      handler: function (val) {
      if (!val) return
        this.memo = val.memo
      },
      deep: true,
      immediate: true,
    }
  }
}
</script>
